import React, { useRef } from 'react';
import { useModule } from '../../context/ModuleContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

// Amazon-style colored tile backgrounds for each module
const TILE_COLORS = {
  agri:      { bg:'#E8F5CE', iconBg:'#4D7C0F', text:'#1a2e05' },
  nursery:   { bg:'#D1FAE5', iconBg:'#059669', text:'#064E3B' },
  organic:   { bg:'#ECFDF5', iconBg:'#10B981', text:'#064E3B' },
  ecommerce: { bg:'#EEF2FF', iconBg:'#4338CA', text:'#1E1B4B' },
  // land:      { bg:'#FEF3C7', iconBg:'#D97706', text:'#451A03' },
};

export default function ModuleStrip() {
  const { activeModule, allModules, switchModule } = useModule();
  const navigate = useNavigate();
  const stripRef = useRef();

  const handleSelect = (mod) => {
    if (!mod.enabled) {
      toast(`${mod.name} — coming soon! 🚀`, { icon:'⏳', duration:2000 });
      return;
    }
    switchModule(mod.id);
    if (mod.id === 'agri')      navigate('/');
    if (mod.id === 'nursery')   navigate('/nursery');
    if (mod.id === 'organic')   navigate('/organic');
    if (mod.id === 'ecommerce') navigate('/shop');
    // if (mod.id === 'land')      navigate('/land');
  };

  return (
    <div ref={stripRef} style={{
      display:'flex', overflowX:'auto', scrollbarWidth:'none',
      padding:'6px 8px 4px', gap:4, background:'transparent',
    }}>
      {allModules.map(mod => {
        const isActive   = mod.id === activeModule.id;
        const isDisabled = !mod.enabled;
        const tile       = TILE_COLORS[mod.id] || TILE_COLORS.agri;

        return (
          <button key={mod.id} onClick={() => handleSelect(mod)} style={{
            flexShrink:0, display:'flex', flexDirection:'column', alignItems:'center',
            gap:5, padding:0, border:'none', background:'none', cursor:'pointer',
            opacity: isDisabled ? 0.55 : 1,
          }}>
            {/* Amazon-style square tile */}
           <div style={{
  width:46, height:46, borderRadius:9,
  background: isActive ? tile.iconBg : tile.bg,
  display:'flex', alignItems:'center', justifyContent:'center',
  fontSize:20,
  border: isActive ? `3px solid white` : '3px solid transparent',
  transition:'all .2s',
  position:'relative',
  overflow:'hidden',
}}>
              {/* {mod.icon} */}
              {/* <img
  src={mod.icon}
  alt={mod.name}
  style={{
    width: 34,
    height: 34,
    objectFit: 'contain'
  }}
/> */}

<img
  src={mod.icon}
  alt={mod.name}
  style={{
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  }}
/>


              {isDisabled && (
                <div style={{
                  position:'absolute', top:-2, right:-2,
                  width:16, height:16, borderRadius:'50%',
                  background:'#F59E0B', border:'2px solid #1A6B3C',
                  display:'flex', alignItems:'center', justifyContent:'center',
                  fontSize:8, color:'white', fontWeight:700,
                }}>!</div>
              )}
            </div>
            {/* Label */}
            <span style={{
              fontSize:9, fontWeight: isActive ? 700 : 500,
              color: isActive ? 'white' : 'rgba(255,255,255,0.8)',
              whiteSpace:'nowrap',
            }}>{mod.name}</span>
          </button>
        );
      })}
    </div>
  );
}
